import script from "./ClockComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ClockComponent.vue?vue&type=script&setup=true&lang=js"

import "./ClockComponent.vue?vue&type=style&index=0&id=3221ea76&lang=css"

const __exports__ = script;

export default __exports__